'use client';

import configuration from '@/configuration';

/* eslint-disable  */

let gfkClient;

function initGfk(w, d, c, s, id) {
  if (d.getElementById(id)) {
    return;
  }

  w.gfkS2sConf = c;
  w[id] = {};
  w[id].agents = [];
  const api = ['playStreamLive', 'playStreamOnDemand', 'stop', 'skip', 'screen', 'volume', 'impression'];
  w.gfks = (function () {
    function f(sA, e, cb) {
      return function () {
        sA.p = cb();
        sA.queue.push({ f: e, a: arguments });
      };
    }
    function s(c, pId, cb) {
      const sA = { queue: [], config: c, cb, pId };
      for (let i = 0; i < api.length; i++) {
        const e = api[i];
        sA[e] = f(sA, e, cb);
      }
      return sA;
    }
    return s;
  })();
  w[id].getAgent = function (cb, pId) {
    const a = {
      a: new w.gfks(
        c,
        pId || '',
        cb ||
          (() => {
            return 0;
          }),
      ),
    };
    function g(a, e) {
      return function () {
        return a.a[e].apply(a.a, arguments);
      };
    }
    for (let i = 0; i < api.length; i++) {
      const e = api[i];
      a[e] = g(a, e);
    }
    w[id].agents.push(a);
    return a;
  };

  const lJS = function (eId, url) {
    const tag = d.createElement(s);
    const el = d.getElementsByTagName(s)[0];
    tag.id = eId;
    tag.async = true;
    tag.type = 'text/javascript';
    tag.src = url;
    tag.setAttribute('crossorigin', 'anonymous');
    el.parentNode.insertBefore(tag, el);
  };

  lJS(id, c.url);
  gfkClient = w[id];
}
(() => {
  try {
    if (!configuration.gfk) {
      console.log('Configuration not loaded');
      return;
    }
    const gfkS2sConf = {
      media: configuration.gfk.media,
      // url:    "//es-config.sensic.net/s2s-web.js", // for production
      url: configuration.gfk.url, // for preproduction
      type: 'WEB',
      // optin:    true,  //optional
      // logLevel: "none" //optional,
      crashReporting: true, // optional
    };
    if (typeof window !== 'undefined') {
      initGfk(window, document, gfkS2sConf, 'script', 'gfkS2s');
    }
  } catch (e) {
    console.error(e);
  }

})();

export default gfkClient;
